import { Component, Input, OnInit } from '@angular/core';
import { FilterModel } from 'src/app/@core/models/filter.model';
import { StudentCourseService } from 'src/app/course/services/student-course.service';
import { LanguageService } from 'src/app/services/language.service';
import { LanguageEnum } from 'src/app/shared/models/item.model';
import { HomeSectionModel } from '../../models/home-section.model';
import { HomeSectionType } from '../../enums/home-section-type.enum';
import { CourseTypeEnum } from 'src/app/course/enums';
import { Course } from 'src/app/shared/models/course';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';

@Component({
  selector: 'app-live-courses',
  templateUrl: './live-courses.component.html',
  styleUrls: ['./live-courses.component.scss']
})
export class LiveCoursesComponent implements OnInit {
  constructor(private errorHandler: ErrorHandlerService, private _StudentCourseService:StudentCourseService, private _LanguageService:LanguageService){}
  @Input() courseTypeSectionsStatus: HomeSectionModel[];
  recordedFilter: FilterModel = new FilterModel(0, 30);
  type: CourseTypeEnum = CourseTypeEnum.LiveSessions;
  currentType: CourseTypeEnum;
  liveCourses: Course[] = [];
  isRtl:boolean = true
  homeSections = HomeSectionType;
  courseType = CourseTypeEnum;

  ngOnInit(): void {
    this.isRtl = this._LanguageService.getCurrentLanguage() === LanguageEnum.ar;
    this._LanguageService.languageChange.subscribe((result: LanguageEnum) => this.isRtl = result === LanguageEnum.ar);
    this.getCourses();
  }

  getCourses(){
    if(this.currentType === this.type) return;
    this.currentType = this.type;
    this._StudentCourseService.getPaging(this.recordedFilter, `types=0,2,3&forDiploma=false`).subscribe({
      next: data => this.liveCourses = data.data,
      error: (error: HttpErrorResponse) => console.log(error)
    });
  }

  checkLength(courseType: CourseTypeEnum){
    return this.liveCourses.filter(c => c.type === courseType).length;
  }

  getCoursesList(courseType: CourseTypeEnum) {
    var courses = this.liveCourses.filter(c => c.type === courseType).slice(0, 4);

    if (courses.length > 0) return courses;
    
    if (!courses.length && courseType === CourseTypeEnum.LiveSessions) {
      courses = this.liveCourses.filter(c => c.type === CourseTypeEnum.OnSite).slice(0, 4);
      this.type = CourseTypeEnum.OnSite;
    }

    else if (!courses.length && courseType === CourseTypeEnum.OnSite) {
      courses = this.liveCourses.filter(c => c.type === CourseTypeEnum.Compact).slice(0, 4);
      this.type = CourseTypeEnum.Compact;
    }

    else if (!courses.length && courseType === CourseTypeEnum.Compact) {
      courses = this.liveCourses.filter(c => c.type === CourseTypeEnum.LiveSessions).slice(0, 4);
      this.type = CourseTypeEnum.LiveSessions;
    }

    return courses;
  }
}
